export default __webpack_public_path__ + "static/media/stress.fb1c2e6a.svg";